export const BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const HARD_COVER_PRICE = process.env.VUE_APP_API_HARD_COVER_PRICE
export const PHONE_VERIFICATION_ENABLED = process.env.VUE_APP_API_PHONE_VERIFICATION_ENABLED === 'true'
export const BASE_IMAGE_PREFIX = process.env.VUE_APP_API_BASE_IMAGE_PREFIX
export const PLACEHOLDER_IMAGE = 'https://media-prod.sehrish-mart-tech.workers.dev/placeholder-product.jpg'